import request from 'superagent';
import Immutable from 'immutable';
import url from '../../utils/url';
import * as actionTypes from '../actionTypes/localCourtSearchActionTypes';
import dateFormat from '../../utils/dateFormat';
import { notify } from '../../components/common/Notification';

const getParams = (payload) => {
  const { filed_from, filed_to, ...values } = payload;
  return {
    open_cases: true,
    closed_cases: true,
    ...values,
    ...(filed_from && { filed_from: dateFormat(filed_from) }),
    ...(filed_to && { filed_to: dateFormat(filed_to) }),
  };
};

export const searchBankruptcy = payload => (dispatch) => {
  dispatch({
    type: actionTypes.LOCAL_COURT_SEARCH_BANKRUPTCY.REQUEST,
    payload,
  });

  const onSuccess = (params, response) =>
    dispatch({
      type: actionTypes.LOCAL_COURT_SEARCH_BANKRUPTCY.SUCCESS,
      params,
      searchResults: response || {},
    });

  const onError = (error) => {
    dispatch({
      type: actionTypes.LOCAL_COURT_SEARCH_BANKRUPTCY.ERROR,
      error,
      payload,
    });

    notify.error('Failed to search Bankruptcy Local Court');
  };

  return request
    .post(url(`/rpc/capi/courts/pacer/${payload.court_code}/cases/search/bankruptcy`))
    .set('Accept', 'application/json')
    .type('form')
    .send(getParams(payload))
    .then(
      ({ body }) => onSuccess(Immutable.fromJS(payload), body),
      error => onError(error),
    );
};

export const searchDistrict = payload => (dispatch) => {
  dispatch({
    type: actionTypes.LOCAL_COURT_SEARCH_DISTRICT.REQUEST,
    payload,
  });

  const onSuccess = (params, response) =>
    dispatch({
      type: actionTypes.LOCAL_COURT_SEARCH_DISTRICT.SUCCESS,
      params,
      searchResults: response || {},
    });

  const onError = (error) => {
    dispatch({
      type: actionTypes.LOCAL_COURT_SEARCH_DISTRICT.ERROR,
      error,
      payload,
    });

    notify.error('Failed to search District Local Court');
  };

  return request
    .post(url(`/rpc/capi/courts/pacer/${payload.court_code}/cases/search/district`))
    .set('Accept', 'application/json')
    .type('form')
    .send(getParams(payload))
    .then(
      ({ body }) => onSuccess(Immutable.fromJS(payload), body),
      error => onError(error),
    );
};

export const searchAppellate = payload => (dispatch) => {
  dispatch({
    type: actionTypes.LOCAL_COURT_SEARCH_APPELLATE.REQUEST,
    payload,
  });

  const onSuccess = (params, response) =>
    dispatch({
      type: actionTypes.LOCAL_COURT_SEARCH_APPELLATE.SUCCESS,
      params,
      searchResults: response || {},
    });

  const onError = (error) => {
    dispatch({
      type: actionTypes.LOCAL_COURT_SEARCH_APPELLATE.ERROR,
      error,
      payload,
    });

    notify.error('Failed to search Appellate Local Court');
  };

  return request
    .post(url(`/rpc/capi/courts/pacer/${payload.court_code}/cases/search/appellate`))
    .set('Accept', 'application/json')
    .type('form')
    .send(getParams(payload))
    .then(
      ({ body }) => onSuccess(Immutable.fromJS(payload), body),
      error => onError(error),
    );
};

export const resetLocalCourtSearch = () => dispatch =>
  dispatch({
    type: actionTypes.LOCAL_COURT_SEARCH_RESET,
  });



// WEBPACK FOOTER //
// ./src/redux/actions/localCourtSearchAction.js